import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
export var insiderMembershipState = function(retailer) {
    var _retailer_insider_membership_state;
    return (_retailer_insider_membership_state = retailer === null || retailer === void 0 ? void 0 : retailer.insider_membership_state) !== null && _retailer_insider_membership_state !== void 0 ? _retailer_insider_membership_state : IRetailer.InsiderMembershipState.NOT_ELIGIBLE;
};
export var isInsider = function(retailer) {
    return insiderMembershipState(retailer) === IRetailer.InsiderMembershipState.ACTIVE;
};
